import * as Styled from './SkeletonLoader.styled';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const FrequencyButtonFieldset = ({
  variant
}) => /*#__PURE__*/_jsx(Styled.FrequencyButtonFieldset, {
  variant: variant,
  children: /*#__PURE__*/_jsx(Styled.FrequencyButtonSkeleton, {
    isActive: false,
    children: /*#__PURE__*/_jsx("span", {
      children: "\xA0"
    })
  })
});
export const Fieldset = () => {
  const defaultAmounts = [{
    amount: 0,
    isDefault: false,
    isVisible: true,
    name: 'preset1'
  }, {
    amount: 0,
    isDefault: false,
    isVisible: true,
    name: 'preset2'
  }, {
    amount: 0,
    isDefault: false,
    isVisible: true,
    name: 'preset3'
  }, {
    amount: 0,
    isDefault: false,
    isVisible: true,
    name: 'preset4'
  }];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [defaultAmounts.map(preset => /*#__PURE__*/_jsx(Styled.AmountButtonSkeleton, {
      isActive: false,
      isOneBigButton: false,
      children: /*#__PURE__*/_jsx("span", {
        children: "\xA0"
      })
    }, preset.name)), /*#__PURE__*/_jsxs(Styled.OtherButtonSkeleton, {
      error: false,
      isActive: false,
      children: [/*#__PURE__*/_jsx("span", {
        children: "\xA0"
      }), /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx("span", {
          children: "\xA0"
        })
      })]
    }), /*#__PURE__*/_jsx("span", {})]
  });
};
export const ProgramDesignationsSearch = () => /*#__PURE__*/_jsx(Styled.SearchSelectSkeleton, {});